import { State, Action, StateContext } from '@ngxs/store';
import { ClearOrderMetadata, SetOrderMetadata } from './order-metadata.actions';
import { Injectable } from '@angular/core';
import { OrderMetadataStateModel } from './order-metadata.type';

@State<OrderMetadataStateModel>({
  name: 'orderMetadata',
  defaults: {
    orderServiceId: null,
    orderCaptureId: null,
    customerId: null,
  },
})
@Injectable()
export class OrderMetadataState {
  @Action(SetOrderMetadata)
  setOrderMetadata(ctx: StateContext<OrderMetadataStateModel>, action: SetOrderMetadata) {
    ctx.patchState(action.payload);
  }

  @Action(ClearOrderMetadata)
  clearOrderMetadata(ctx: StateContext<OrderMetadataStateModel>) {
    ctx.setState({
      orderServiceId: null,
      orderCaptureId: null,
      customerId: null,
    });
  }
}
